"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.prefix = void 0;
var prefix = "@@api/";
exports.prefix = prefix;

var _default = function _default(name) {
  return {
    request: "".concat(prefix).concat(name, "/REQUEST"),
    success: "".concat(prefix).concat(name, "/SUCCESS"),
    failure: "".concat(prefix).concat(name, "/FAILURE")
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-future-middleware/lib/helpers/createTypes.js
// module id = 1223
// module chunks = 0